<template>
  <div class="from_box flex">
    <div class="item">
      <span class="txt">工厂：</span>
      <el-autocomplete
        v-model="fromData.factoryStr"
        :fetch-suggestions="factoryQuerySearchAsync"
        :placeholder="$store.state.remark.factory"
        :trigger-on-focus="false"
        :disabled="fromData.changeDisaStatus"
        @select="handleSelectFactory"
        @keyup.enter.native="enterHandleSelectFactory"
        @blur="enterHandleSelectFactory"
        ref="factoryAuto"
        clearable
        @clear="factoryClear"
      ></el-autocomplete>
    </div>

    <div class="item">
      <span class="txt">库存地点：</span>
      <el-select
        v-model="fromData.inventoryId"
        @change="changeFstock"
        :disabled="fromData.changeDisaStatus"
        placeholder="请选择库存地点"
      >
        <el-option
          v-for="item in fstockList"
          :label="item.value"
          :key="item.inventoryId"
          :value="item.inventoryId"
        >
          <span style="float: left">{{ item.inventoryCode}}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.inventoryDesc}}</span>
        </el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">生产订单：</span>
      <el-input
        v-model="fromData.productOrderNo"
        clearable
        :disabled="fromData.disabledStatus"
        placeholder="暂无生产订单号"
        @keyup.enter.native="enterGetSaleData($event)"
      ></el-input>
    </div>

    <!-- <div class="item">
      <span class="txt">订单类型：</span>
      <el-input v-model="fromData.orderType" placeholder="pp02" :disabled="fromData.changeDisaStatus"></el-input>
    </div> -->

    <div class="item">
      <span class="txt">订单类型：</span>
      <el-select v-model="fromData.orderType"  @change="changeOrderType" :disabled="fromData.changeDisaStatus" placeholder="请选择订单类型">
        <el-option
          v-for="item in this.saleVoucherTypeList"
          :label="item.value"
          :key="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">物料编码：</span>
      <el-autocomplete
        v-model="fromData.materialCode"
        :fetch-suggestions="querySearchAsync"
        :disabled="fromData.changeDisaStatus"
        placeholder="请输入物料编码或物料描述"
        @select="handleSelect"
        clearable
      ></el-autocomplete>
    </div>

    <div class="item">
      <span class="txt">物料描述：</span>
      <el-input v-model="fromData.materialDesc" placeholder="暂无物料描述" :disabled="fromData.disabledStatus"></el-input>
    </div>

    <div class="item">
      <span class="txt">创建日期：</span>
      <el-date-picker v-model="fromData.createDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">BOM版本：</span>
      <el-select v-model="fromData.optionBom" @focus="focusOptionBom" @change="changeOptionBom" placeholder="暂无BOM版本" clearable>
        <el-option
          v-for="item in this.optionBomList"
          :label="item"
          :key="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">订单状态：</span>
      <el-input v-model="fromData.orderStates" placeholder="0001" :disabled="fromData.disabledStatus"></el-input>
    </div>

    <div class="item" style="width:15%;margin-left:-14%">
      <span class="txt">删除标记：</span>
      <el-checkbox style="margin-top:8px" v-model="fromData.delId" :disabled="true"></el-checkbox>
    </div>

    <div class="item" style="width:15%;margin-right:10%">
      <span class="txt">订单自动发货：</span>
      <el-checkbox style="margin-top:8px" v-model="fromData.autoGr"></el-checkbox>
    </div>
  </div>
</template>

<script>
import { sendOrder } from "api/business.js";
import { matterApi, fstockApi ,bomApi } from "api/base.js";

export default {
  components: {},
  props: {
    fromData: Object,
    salesId: Number,
    factoryList: Array
  },
  data() {
    return {
      saleVoucherTypeList: ["pp01","pp02"],//订单类型
      OptionBom:[],
      state:true,
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      optionBomList: [],
      restaurants: [],
      timeout: null,
      //销售订单Id
      saleId: "",
      //已选的工厂
      factoryListRes: {},
      fstockList: [], //库存地信息
      //获取库位信息
      fromFstock: {
        page: 1,
        pageSize: 10000,
        searchCriteria: {}
      },
    };
  },
  created() {
    //凭证和过账默认今天
    let nowData = new Date();
    this.$set(this.fromData, "createDate", nowData);
  },
  computed: {},
  watch: {
      fromData: function(val) {
    //   console.log(val);
    }
  },
  mounted() {
      this.restaurants = this.loadAll();
    },
  methods: {
    async loadAll() {
      let res = await this.$post(matterApi.list, this.$store.state.getAllPage);
      if (res.status) {
          console.log(res)
        let materialList = [];
        res.data.list.forEach(item => {
          item.value =item.materialCode + '-' + item.materialDesc
          materialList.push(item);
        });
        this.restaurants = materialList;
      } else {
        console.log(res.error);
      }
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      console.log(restaurants, "=====");
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 10 * Math.random());
    },
    //物料编码点击选中建议项时触发
    handleSelect(item) { 
      // console.log(item);
      this.optionBomList = []
      this.state = true
     
      this.fromData.materialId = item.materialId;
      this.fromData.materialCode = item.materialCode;
      this.fromData.materialDesc = item.materialDesc;

      this.fromData.entryUnitId = item.basicUnitId;
      this.fromData.entryUnitCode = item.basicUnitCode;
      this.fromData.entryUnitDesc = item.basicUnitDesc;

      this.fromData.basicUnitId = item.basicUnitId;
      this.fromData.basicUnit = item.basicUnitCode;
      this.fromData.basicUnitDesc = item.basicUnitDesc;

      this.fromData.bomBasicUnitId = item.basicUnitId;
      this.fromData.bomBasicUnit = item.basicUnitCode;
      this.fromData.bomBasicUnitName = item.basicUnitDesc;
    },
    //获取库位信息
    async getFstock(fid) {
      this.fromFstock.searchCriteria.factoryId = fid;
      let fstockList = await this.$post(fstockApi.list, this.fromFstock);
      if (!fstockList.status) return false;
      if (fstockList.data) {
        this.isFactoryInventory = false;
        this.fstockList = fstockList.data.list;
        this.fstockList.forEach(item => {
          item.value = item.inventoryCode + "-" + item.inventoryDesc;
        });
      } else {
        this.fstockList = [];
      }
    },
    //库位信息改变
    changeFstock(val) {
      let res = this.fstockList.find(v => v.inventoryId == val);
      if (res) {
        this.fromData.inventoryCode = res.inventoryCode;
        this.fromData.inventoryDesc = res.inventoryDesc;
        this.fromData.inventoryId = res.inventoryId;
      } else {
        this.fromData.inventoryCode = "";
        this.fromData.inventoryDesc = "";
        this.fromData.inventoryId = "";
      }
    },
    //工厂检索
    factoryQuerySearchAsync(queryString, cb) {
      var restaurants = this.factoryList;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      this.factoryListRes = results;
      /* this.timeout = setTimeout(() => {
			}, 1000 * Math.random()); */
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        if (state.value) {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1
          );
        }
      };
    },
    //工厂
    enterHandleSelectFactory() {
      if (!this.fromData.factoryStr) return false;
      if (this.factoryListRes.length) {
        let item = this.factoryListRes[0];
        this.handleSelectFactory(item);
      } else {
        let fcode = this.fromData.factoryCode;
        let res = this.factoryList.find(v => v.factoryCode === fcode);
        if (res) {
          this.handleSelectFactory(res);
        } else {
          this.$message.error("没有此工厂");
          this.fromData.factoryId = "";
          this.fromData.factoryCode = "";
          this.fromData.factoryDesc = "";
          this.fstockList = [];
          this.isFactoryInventory = true;
        }
      }
    },
    //选择工厂后
    handleSelectFactory(item) {
      if (item.factoryId != this.fromData.factoryId) {
        //重新获取库位数据
        this.getFstock(item.factoryId);
      }
      this.fromData.planFactory = item.factoryCode;
      this.fromData.planFactoryDesc = item.factoryDesc;
      this.fromData.planFactoryId = item.factoryId;
      this.fromData.factoryStr = item.factoryCode + "-" + item.factoryDesc;
      this.isFactoryInventory = false;
    },
    //清空工厂
    factoryClear() {
      this.$set(this.fromData, "planFactoryId", "");
      this.$set(this.fromData, "planFactory", "");
      this.$set(this.fromData, "planFactoryDesc", "");

      this.$set(this.fromData, "inventoryId", "");
      this.$set(this.fromData, "inventoryCode", "");
      this.$set(this.fromData, "inventoryDesc", "");

      this.fstockList = [];
      this.isFactoryInventory = true;
    },
    //BOM版本获得焦点时
   async focusOptionBom(){
        let OptionBoms = {}
        OptionBoms.factoryId = this.fromData.planFactoryId
        OptionBoms.factoryCode = this.fromData.planFactory
        OptionBoms.factoryDesc = this.fromData.planFactoryDesc
        OptionBoms.materialId = this.fromData.materialId
        OptionBoms.materialCode = this.fromData.materialCode
        OptionBoms.materialDesc = this.fromData.materialDesc
        //  console.log(OptionBoms)
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$post(bomApi.search, OptionBoms);
        // console.log(res)
        this.isLoading = false;
        if(res.status && this.state == true){
            // console.log(res.data)
            this.OptionBom = res.data
            res.data.forEach((item,index)=>{
                this.optionBomList.push(item.optionBom)
            })
            console.log(this.optionBomList)
            this.state = false
        }else{
            // this.$message.warning(res.errorMsg + "，请换个物料试试！");
        }
    },
    //BOM版本改变时
    changeOptionBom(val){
      this.fromData.changeDisaStatus = true
      console.log(val)
        this.OptionBom.forEach((item)=>{
          if(item.optionBom == val){
            this.fromData.bomDto = item
          }
        })
         console.log(this.fromData)
    },
    //订单类型选择
    changeOrderType(val){ 
          console.log(val)
          if(val == "pp01"){
            this.fromData.orderType = "pp01"
            console.log(this.fromData)
          }
          if(val == "pp02"){
            this.fromData.orderType = "pp02"
            console.log(this.fromData)
          }
      },
  }
};
</script>

<style>
</style>
